import styled from "styled-components"

export const Container = styled.div`
    margin: 1rem 0.5rem;

    table{
        border-collapse: collapse;
        border-radius: 10px;
        overflow: hidden;
        margin: 2rem 0;
        width: 100%;
        cursor: pointer;

        thead{
            tr{
                background: #7A05A7;
                color: #FFF;
                text-align: center;
            }

            .title-cliente p{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                padding-left: 10px;
            }

            .isWideVersion p{
                width: 100%;
                display: flex;
                justify-content: flex-end;
                padding-right: 10px;
            }
        }
    
        tbody{
            tr{
                border-bottom: 1px solid #DDD;
                text-align: center;
                color: #535354;

                td:first-child{
                    width: 10px;
                }
    
                &:nth-child(even){
                    background: #f3f3f3;
                }

                td {
                    background: transparent;
                    border: none;
                    color: #535354;    
                }

                .name p{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    padding-left: 10px;
                }


                .isWideVersion p{
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    padding-right: 10px;
                }
            }
        }
    
    
        th, td{
            padding: 0.7rem 0.9rem;
          
        } 

        td{
            div{
                height: 0.9rem;
                width: 0.9rem;
                border-radius: 50%;
                margin: 0 auto;
            }
        }

        .A{
            div{
                background: #e05f59;
            }
        }

        .E{
            div{
                background: #4A007A;
            }
        }
        
        .R{
            div{
                background: #F0E68C;
            }
        }

        .F{
           div{
                background: #2e9699;
           }
        }
        
        @media (max-width: 650px){
            thead{
                .title-cliente p{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                }
            }

            
            tbody{
                tr{
                    .name p{
                        width: 100%;
                        display: flex;
                        justify-content:center;
                    }
                }
            }
        }

        @media (max-width: 425px){
            font-size: 0.9rem;

            th, td{
                padding: 0.6rem;
            }


            .isWideVersion{
                display: none;
            }
        }
    }

    button{
        max-width: 400px;
        margin: 0 auto;
    }
`